angular.module("survey").directive("bindMerge", ["$compile", bindMerge]);

function bindMerge($compile) {
  return {
    restrict: "A",
    scope: false,
    link: ($scope, $elem, $attrs) => {
      if ($scope.survey.config.compile) {
        const compiled = $compile("<div>" + ($scope.$eval($attrs.bindMerge) || "") + "</div>")($scope);
        $elem.append(compiled[0].childNodes);
      } else {
        $elem.append($scope.$eval($attrs.bindMerge));
      }
    }
  }
}